import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CandidatePageAction } from "../../../Redux/action/CandidatePageAction";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  FaCheckCircle,
  FaEllipsisV,
  FaEye,
  FaTimesCircle,
} from "react-icons/fa";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";

import Pagination from "../../Common/Pagination/Pagination";
import { MdAddTask, MdDelete } from "react-icons/md";
import {
  ActivateCandidate,
  DeactivateCandidate,
} from "../../../Services/candidateServies";
import { FiFilter } from "react-icons/fi";
import {
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../../Redux/action/MasterSkillAction";
import Select from "react-select";
import noImage from "../../../images/dummy_dp.png";
import dayjs from "dayjs";

const primaryColor = "#286a94";

const CandidatePage = () => {
  const [data, setData] = useState({
    designation: "",
    minExperience: "",
    maxExperience: "",
    search: "",
    skills: [],
    locations: [],
    pageNumber: 0,
    pageSize: 10,
    status: "",
    // "flag": false
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activateModal, setActivateModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [designationSendapi, setDesignationSendAPI] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skillVal, setSkillVal] = useState([]);
  const [activeTab, setActiveTab] = useState("ALL");
  const [filterActive, setFilterActive] = useState("ALL");
  const [id, setid] = useState();
  const [isloading, setIsLoading] = useState(false);
  const loader = useSelector((state) => state?.CandidatePageDashboard?.loading);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sortModel, setSortModel] = useState([]);

  const { candidateData, totalElements, AllDesignationList, AllSkillList } =
    useSelector(
      (state) => ({
        candidateData: state?.CandidatePageDashboard?.result?.content || [],
        totalElements:
          state?.CandidatePageDashboard?.result?.totalElements || 0,
        AllDesignationList:
          state?.MasterTableDetails?.designation?.content || [],
        AllSkillList: state?.MasterTableDetails?.skill?.content || [],
      }),
      shallowEqual,
    );

  const PAGE_SIZE_GAP = 10;
  const MAX_PAGE_SIZE = 50;
  const pageSizeOptions = Array.from(
    { length: MAX_PAGE_SIZE / PAGE_SIZE_GAP },
    (_, i) => (i + 1) * PAGE_SIZE_GAP,
  );
  const safePageSize = pageSizeOptions.includes(data.pageSize)
    ? data.pageSize
    : pageSizeOptions[0];
  const rows =
    candidateData?.map((item) => ({
      id: item.candidateId,
      ...item,
    })) || [];

  const columns = [
    {
      field: "candidate_type",
      headerName: "Candidate ID",
      width: 160,
      sortable: true,
      renderCell: (params) => (
        <Chip
          label={params.value}
          sx={{
            backgroundColor: params.row.isTeamMember ? "#E3F2FD" : "#FFF3E0",
            color: params.row.isTeamMember ? "#1565C0" : "#EF6C00",
            fontWeight: 600,
          }}
        />
      ),
    },
    {
      field: "name",
      headerName: "Name",
      width: 240,
      sortable: true,
      valueGetter: (params) =>
        `${params.row.firstName || ""} ${params.row.lastName || ""}`,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar
            src={params.row.profileImageUrl || undefined}
            sx={{
              width: 40,
              height: 40,
              bgcolor: !params.row.profileImageUrl ? "#2d6d96" : undefined,
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            {!params.row.profileImageUrl &&
              `${params.row.firstName?.[0] || ""}${params.row.lastName?.[0] || ""}`?.toUpperCase()}
          </Avatar>

          <Typography noWrap sx={{ maxWidth: 160 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "currentDesignation",
      headerName: "Designation",
      width: 180,
      sortable: true,
      valueGetter: (p) => p.value || "N/A",
    },
    {
      field: "experience",
      headerName: "Experience",
      width: 170,
      cellClassName: "wrap-cell",
      sortable: false,
      valueGetter: (p) => {
        const y = parseInt(p.row.keyExperience) || 0;
        const m = parseInt(p.row.keyExperienceInMonth) || 0;
        if (!y && !m) return "Fresher";
        if (!m) return `${y} Year${y > 1 ? "s" : ""}`;
        if (!y) return `${m} Month${m > 1 ? "s" : ""}`;
        return `${y} Years ${m} Months`;
      },
    },
    {
      field: "activeStatus",
      headerName: "Status",
      width: 160,
      sortable: true,
      renderCell: (p) =>
        p.value ? (
          <Chip
            icon={<FaCheckCircle size={14} color="#2e7d32" />}
            label="Active"
            sx={{ backgroundColor: "#e0f7e9", color: "#2e7d32" }}
          />
        ) : (
          <Chip
            icon={<FaTimesCircle color="#d32f2f" size={14} />}
            label="Deactivated"
            sx={{ backgroundColor: "#ffe5e5", color: "#d32f2f" }}
          />
        ),
    },
    {
      field: "lastLogin",
      headerName: "Last Login",
      cellClassName: "wrap-cell",
      width: 200,
      sortable: true,
      valueGetter: (p) => (p.value ? formatCustomDate(p.value) : "—"),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 200,
      sortable: true,
      cellClassName: "wrap-cell",
      valueGetter: (p) =>
        p.value ? dayjs(p.value).format("DD MMM YYYY, hh:mm A") : "—",
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              toggleOptions(params.row.candidateId);
              setAnchorEl(e.currentTarget);
            }}
          >
            <FaEllipsisV fontSize={16} color="#2d6d96"/>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={showOptionsForId === params.row.candidateId}
            onClose={() => {
              setShowOptionsForId(null);
              setAnchorEl(null);
            }}
            PaperProps={{ sx: { width: 170, borderRadius: 2 } }}
          >
            <MenuItem
              onClick={() =>
                navigate(
                  `/admin/candidate/viewCandidate?candidateId=${params.row.candidateId}`,
                )
              }
            >
              <FaEye style={{ marginRight: 8 }} color="#2d6d96"/> View
            </MenuItem>

            {params.row.activeStatus ? (
              <MenuItem
                onClick={() => {
                  setDeactivateModal(true);
                  setid(params.row.candidateId);
                }}
              >
                <MdDelete style={{ marginRight: 8 }} color="red" /> Deactivate
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  setActivateModal(true);
                  setid(params.row.candidateId);
                }}
              >
                <MdAddTask style={{ marginRight: 8 }} color="green" /> Activate
              </MenuItem>
            )}
          </Menu>
        </>
      ),
    },
  ];

  useEffect(() => {
    data.designation = designationSendapi;
    data.status = filterActive;
    data.skills = skillVal;
    const fetchData = async () => {
      dispatch(CandidatePageAction(data));
    };
    fetchData();
  }, [
    data,
    dispatch,
    activateModal,
    deactivateModal,
    selectedDesignation,
    filterActive,
    activeTab,
    selectedSkills,
  ]);

  const handleDesignationChange = (selectedOptions) => {
    setSelectedDesignation(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setDesignationSendAPI(selectedValues);
  };
  const handleSkillsChange = (selectedOptions) => {
    setSelectedSkills(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setSkillVal(selectedValues);
  };

  const [showOptionsForId, setShowOptionsForId] = useState(null);
  const optionsRef = useRef(null);

  const toggleOptions = (id) => {
    setShowOptionsForId(showOptionsForId === id ? null : id);
  };

  const handlePageChange = (page) => {
    setData((prev) => ({
      ...prev,
      pageNumber: page,
    }));
  };

  useEffect(() => {
    dispatch(fetchDesignationDetails());
    dispatch(fetchSkillDetails());
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptionsForId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handleActivate() {
    setIsLoading(true);
    ActivateCandidate(id)
      .then((res) => {
        setIsLoading(false);
        setActivateModal(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function handleDeactivate() {
    setIsLoading(true);
    DeactivateCandidate(id)
      .then((res) => {
        setIsLoading(false);
        setDeactivateModal(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }
  const designationOptions = AllDesignationList?.map((item) => ({
    value: item?.designation,
    label: item?.designation,
  }));
  const options = AllSkillList?.map((item) => ({
    value: item?.skillName,
    label: item?.skillName,
  }));

  const reactSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 36,
      borderRadius: 8,
      borderColor: state.isFocused ? "#286a94" : "#e2e8f0",
      boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
      fontSize: 13,
      "&:hover": { borderColor: "#286a94" },
    }),
    option: (base, state) => ({
      ...base,
      fontSize: 13,
      padding: "6px 10px",
      backgroundColor: state.isSelected
        ? "#286a94"
        : state.isFocused
          ? "#e6f2fa"
          : "#fff",
      color: state.isSelected ? "#fff" : "#334155",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#e6f2fa",
      borderRadius: 6,
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: 12,
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: 13,
      color: "#64748b",
    }),
  };

  const formatCustomDate = (dateStr) => {
    if (!dateStr) return "—";
    // "31-12-2025 12:07:31 IST"
    const [datePart, timePart] = dateStr.split(" ");
    if (!datePart || !timePart) return "—";

    const [day, month, year] = datePart.split("-");
    const isoLikeDate = `${year}-${month}-${day}T${timePart}`;

    const date = new Date(isoLikeDate);
    if (isNaN(date.getTime())) return "—";

    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace("am", "AM")
      .replace("pm", "PM");
  };

  return (
    <div
      style={{
        backgroundColor: "#f6f9ff",
        paddingTop: "25px",
        height: "100vh",
      }}
      className="container-fluid"
    >
      <div className="common_wrapper" style={{ width: "99%" }}>
        <Box
          className="card-header common_table_header"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", xl: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            px: 2,
            py: 1.5,
          }}
        >
          {/* Left: Title */}
          <Typography fontSize={16} fontWeight={600}>
            Candidate Management
          </Typography>

          {/*  Filters + Search */}
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            flexWrap="nowrap"
            sx={{
              width: "100%",
              overflowX: "hidden",
              overflowY: "hidden",
            }}
          >
            {/* Skills */}
            <Box sx={{ flex: 1, minWidth: 180, maxWidth: 240 }}>
              <Select
                options={options}
                isMulti
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  ...reactSelectStyles,
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 1500,
                  }),
                }}
                value={selectedSkills}
                onChange={handleSkillsChange}
                placeholder="Select Skills"
              />
            </Box>

            {/* Designation */}
            <Box sx={{ flex: 1, minWidth: 180, maxWidth: 240 }}>
              <Select
                options={designationOptions}
                isMulti
                value={selectedDesignation}
                onChange={handleDesignationChange}
                placeholder="Select Designation"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  ...reactSelectStyles,
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 1500,
                  }),
                }}
              />
            </Box>

            {/* Status Filter */}
            <Box
              sx={{
                flex: 1,
                minWidth: 160,
                maxWidth: 200,
                position: "relative",
              }}
            >
              <FiFilter
                style={{
                  position: "absolute",
                  top: "50%",
                  left: 10,
                  transform: "translateY(-50%)",
                  color: "#64748b",
                }}
              />
              <select
                value={filterActive}
                onChange={(e) => setFilterActive(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 34px",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "#334155",
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#fff",
                  textTransform: "uppercase",
                  outline: "none",
                }}
              >
                <option value="ALL">All</option>
                <option value="ACTIVE">Activated</option>
                <option value="INACTIVE">Deactivated</option>
                <option value="INDIVIDUAL">Individual</option>
                <option value="TEAM_MEMBER">Team Member</option>
              </select>
            </Box>

            {/* Search */}
            <Box sx={{ flex: 1.5, minWidth: 200 }}>
              <TextField
                size="small"
                fullWidth
                placeholder="Search by name"
                value={data?.search}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    search: e.target.value,
                    pageNumber: 0,
                  }))
                }
                sx={{
                  bgcolor: "#fff",
                  borderRadius: "10px",
                  "& .MuiInputBase-root": { height: 35 },
                  "& .MuiInputBase-input": {
                    fontSize: 14,
                    padding: "10px 12px",
                  },
                  "& fieldset": { borderColor: "#e2e8f0" },
                  "&:hover fieldset": { borderColor: "#286A94" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#286A94",
                    borderWidth: 1.5,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IoSearch size={18} color="#286A94" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Stack>
        </Box>

        <Box
          sx={{
            height: 520,
            width: "100%",
            backgroundColor: "#fff",
            borderRadius: 3,
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            loading={loader}
            disableRowSelectionOnClick
            pagination
            paginationMode="server"
            rowCount={totalElements}
            paginationModel={{
              page: data.pageNumber,
              pageSize: safePageSize,
            }}
            onPaginationModelChange={(model) => {
              setData((prev) => ({
                ...prev,
                pageNumber: model.page,
                pageSize: model.pageSize,
              }));
            }}
            pageSizeOptions={pageSizeOptions}
            sortingMode="client"
            sortModel={sortModel}
            onSortModelChange={(model) => setSortModel(model)}
            disableColumnFilter
            sx={{
              border: "none",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f5f7fa",
                borderBottom: "1px solid #e2e8f0",
              },

              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 700,
                textTransform: "uppercase",
                fontSize: "13px",
                letterSpacing: "0.5px",
                color: "#2d6d96",
              },

              "& .MuiDataGrid-sortIcon": {
                color: "#2d6d96",
              },

              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f0f7fb",
              },

              "& .MuiDataGrid-footerContainer": {
                borderTop: "1px solid #e2e8f0",
              },
            }}
          />
        </Box>
        {/* {candidateData?.length >= 1 && (
          <Box mt={2} display="flex" justifyContent="center">
            <Pagination
              totalPages={totalPages}
              currentPage={data?.pageNumber || 0}
              onPageChange={handlePageChange}
            />
          </Box>
        )} */}
      </div>
      {deactivateModal && (
        <Dialog
          open={deactivateModal}
          onClose={() => {
            setDeactivateModal(false);
            setid("");
          }}
          disableEscapeKeyDown
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Deactivate Candidate
          </DialogTitle>

          <DialogContent sx={{ fontSize: "16px", color: "#333" }}>
            Are you sure you want to deactivate this candidate?
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              disabled={isloading}
              variant="contained"
              className="btn-lg btn-primary-custom"
              onClick={() => handleDeactivate()}
              sx={{
                backgroundColor: primaryColor,
                "&:hover": { backgroundColor: "#1f587a" },
                minWidth: 120,
              }}
            >
              {isloading ? "Loading..." : "Yes, Deactivate"}
            </Button>

            <Button
              variant="outlined"
              className="btn-lg"
              onClick={() => {
                setDeactivateModal(false);
                setid("");
              }}
              sx={{
                borderColor: primaryColor,
                color: primaryColor,
                "&:hover": {
                  borderColor: "#1f587a",
                  color: "#1f587a",
                  backgroundColor: "rgba(40,106,148,0.06)",
                },
                minWidth: 120,
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {activateModal && (
        <Dialog
          open={activateModal}
          onClose={() => {
            setActivateModal(false);
            setid("");
          }}
          disableEscapeKeyDown
        >
          <DialogTitle sx={{ fontWeight: 600 }}>Activate Candidate</DialogTitle>

          <DialogContent sx={{ fontSize: "16px", color: "#333" }}>
            Are you sure you want to activate this candidate? They will regain
            full access immediately.
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              disabled={isloading}
              variant="contained"
              className="btn-lg btn-primary-custom"
              onClick={() => handleActivate()}
              sx={{
                backgroundColor: primaryColor,
                "&:hover": { backgroundColor: "#1f587a" },
                minWidth: 120,
              }}
            >
              {isloading ? "Loading..." : "Yes, Activate"}
            </Button>

            <Button
              variant="outlined"
              className="btn-lg"
              onClick={() => {
                setActivateModal(false);
                setid("");
              }}
              sx={{
                borderColor: primaryColor,
                color: primaryColor,
                "&:hover": {
                  borderColor: "#1f587a",
                  color: "#1f587a",
                  backgroundColor: "rgba(40,106,148,0.06)",
                },
                minWidth: 120,
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default CandidatePage;
